import { render, staticRenderFns } from "./accountsDeposits.vue?vue&type=template&id=a9c6e480"
import script from "./accountsDeposits.vue?vue&type=script&lang=js"
export * from "./accountsDeposits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports